// extracted by mini-css-extract-plugin
export default {"button":"LogoutButton_button__p2-OJ"};